export const RibbonItemConfig = [
  {
    icon: 'assets/icons/brain.svg',
    number: '10 K +',
    description: 'Normal Human Brain Samples'
  },
  {
    icon: 'assets/icons/glioma.svg',
    number: '6.5 K +',
    description: 'Human Glioma Samples'
  },
  {
    icon: 'assets/icons/gene_coexpression.svg',
    number: '250 K +',
    description: 'Gene Coexpression Modules'
  },
  {
    icon: 'assets/icons/geneset.svg',
    number: '40 K +',
    description: 'Gene Sets'
  },
  {
    icon: 'assets/icons/dataset.svg',
    description: 'Standardized Dataset, Sample, & Analysis Metadata'
  }
]